import translator from '@/locales';

const mapPermissionCategoriesToTrans = {
  general: translator.t('AGENTS.GENERAL_PERMISSIONS.TITLE'),
  finance: translator.t('AGENTS.FINANCE_PERMISSIONS.TITLE'),
  app_permissions: translator.t('AGENTS.APP_PERMISSIONS.TITLE'),
};

const mapPermissionsToTrans = {
  general_permissions: {
    add_app: {
      title: translator.t('AGENTS.GENERAL_PERMISSIONS.ADD_APP'),
      description: translator.t(
        'AGENTS.GENERAL_PERMISSIONS.ADD_APP_DESCRIPTION',
      ),
    },
    change_public_info: {
      title: translator.t('AGENTS.GENERAL_PERMISSIONS.CHANGE_PUBLIC_INFO'),
      description: translator.t(
        'AGENTS.GENERAL_PERMISSIONS.CHANGE_PUBLIC_INFO_DESCRIPTION',
      ),
    },
    developers_api: {
      title: translator.t('AGENTS.GENERAL_PERMISSIONS.DEVELOPERS_API'),
      description: translator.t(
        'AGENTS.GENERAL_PERMISSIONS.DEVELOPERS_API_DESCRIPTION',
      ),
    },
    view_finance_info: {
      title: translator.t('AGENTS.GENERAL_PERMISSIONS.VIEW_FINANCIAL_INFO'),
      description: translator.t(
        'AGENTS.GENERAL_PERMISSIONS.VIEW_FINANCIAL_INFO_DESCRIPTION',
      ),
    },
    change_finance_info: {
      title: translator.t('AGENTS.GENERAL_PERMISSIONS.CHANGE_FINANCIAL_INFO'),
      description: translator.t(
        'AGENTS.GENERAL_PERMISSIONS.CHANGE_FINANCIAL_INFO_DESCRIPTION',
      ),
    },
    support: {
      title: translator.t('AGENTS.APP_PERMISSIONS.SUPPORT'),
      description: translator.t('AGENTS.APP_PERMISSIONS.SUPPORT_DESCRIPTION'),
    },
  },
  app_permissions: {
    advertisement: {
      title: translator.t('AGENTS.APP_PERMISSIONS.ADVERTISEMENT'),
      description: translator.t(
        'AGENTS.APP_PERMISSIONS.ADVERTISEMENT_DESCRIPTION',
      ),
    },
    change_app_info: {
      title: translator.t('AGENTS.APP_PERMISSIONS.CHANGE_APP_INFO'),
      description: translator.t(
        'AGENTS.APP_PERMISSIONS.CHANGE_APP_INFO_DESCRIPTION',
      ),
    },
    development: {
      title: translator.t('AGENTS.APP_PERMISSIONS.DEVELOPMENT'),
      description: translator.t(
        'AGENTS.APP_PERMISSIONS.DEVELOPMENT_DESCRIPTION',
      ),
    },
    publish: {
      title: translator.t('AGENTS.APP_PERMISSIONS.PUBLISH'),
      description: translator.t('AGENTS.APP_PERMISSIONS.PUBLISH_DESCRIPTION'),
    },
    statistics: {
      title: translator.t('AGENTS.APP_PERMISSIONS.STATISTICS'),
      description: translator.t(
        'AGENTS.APP_PERMISSIONS.STATISTICS_DESCRIPTION',
      ),
    },
    support: {
      title: translator.t('AGENTS.APP_PERMISSIONS.SUPPORT'),
      description: translator.t('AGENTS.APP_PERMISSIONS.SUPPORT_DESCRIPTION'),
    },
    view_finance: {
      title: translator.t('AGENTS.APP_PERMISSIONS.VIEW_FINANCE'),
      description: translator.t(
        'AGENTS.APP_PERMISSIONS.VIEW_FINANCE_DESCRIPTION',
      ),
    },
  },
};

export function translateGeneralPermission(property) {

  if (property in mapPermissionsToTrans.general_permissions)
    return mapPermissionsToTrans.general_permissions[property];

  throw new Error('Translation not found!');
}

export function translateAppPermission(property) {

  if (property in mapPermissionsToTrans.app_permissions)
    return mapPermissionsToTrans.app_permissions[property];

  return null;
}

export function translatePermissionCategory(property) {
  if (property in mapPermissionCategoriesToTrans)
    return mapPermissionCategoriesToTrans[property];

  throw new Error('Translation not found!');
}
